var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"music",attrs:{"id":"music"},on:{"click":_vm.toggleMusic}},[_c('div',{staticClass:"note",class:_vm.isPlay ? 'rotating on' : 'off'}),_c('audio',{attrs:{"src":_vm.musicURL,"id":"myMusic","preload":"preload","loop":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }